import { AuthContextProps } from "react-oidc-context";
import { config } from "../config";

export const signOut = async (auth: AuthContextProps): Promise<void> => {
  try {
    // First remove the user from the auth context
    await auth.removeUser();

    // Then redirect to Cognito logout
    const clientId = config.auth.clientId;
    const logoutUri = config.auth.redirectUri;
    const cognitoDomain = config.auth.cognitoDomain;

    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  } catch (error) {
    console.error("Logout error:", error);
    // Fallback: force redirect to home
    window.location.href = "/";
  }
};

export const cleanAuthParams = (): void => {
  if (window.history && window.history.replaceState) {
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);
  }
};
